// import PdfIcon from "./icons/PdfIcon";
// import JpgIcon from "./icons/JpgIcon";
// import DefaultIcon from "./icons/DefaultIcon";
import { ReactComponent as CsvIcon } from "images/documents/Type=CSV.svg";
import { ReactComponent as DocIcon } from "images/documents/Type=DOC.svg";
import { ReactComponent as DocxIcon } from "images/documents/Type=DOCX.svg";
import { ReactComponent as PubIcon } from "images/documents/Type=PUB.svg";
import { ReactComponent as TxtIcon } from "images/documents/Type=TXT.svg";
import { ReactComponent as XslIcon } from "images/documents/Type=XSL.svg";
import { ReactComponent as PptIcon } from "images/documents/Type=PPT.svg";
import { ReactComponent as PdfIcon } from "images/documents/Type=PDF.svg";
import { ReactComponent as MdbIcon } from "images/documents/Type=MDB.svg";
import { ReactComponent as ZipIcon } from "images/documents/Type=ZIP.svg";
import { ReactComponent as RarIcon } from "images/documents/Type=RAR.svg";
import { ReactComponent as IsoIcon } from "images/documents/Type=ISO.svg";
import { ReactComponent as ExeIcon } from "images/documents/Type=EXE.svg";
import { ReactComponent as DllIcon } from "images/documents/Type=DLL.svg";
import { ReactComponent as PsdIcon } from "images/documents/Type=PSD.svg";
import { ReactComponent as AiIcon } from "images/documents/Type=AI.svg";
import { ReactComponent as DwgIcon } from "images/documents/Type=DWG.svg";
import { ReactComponent as BmpIcon } from "images/documents/Type=BMP.svg";
import { ReactComponent as JpgIcon } from "images/documents/Type=JPG.svg";
import { ReactComponent as TiffIcon } from "images/documents/Type=TIFF.svg";
import { ReactComponent as GifIcon } from "images/documents/Type=GIF.svg";
import { ReactComponent as FlvIcon } from "images/documents/Type=FLV.svg";
import { ReactComponent as AviIcon } from "images/documents/Type=AVI.svg";
import { ReactComponent as MpegIcon } from "images/documents/Type=MPEG.svg";
import { ReactComponent as RawIcon } from "images/documents/Type=RAW.svg";
import { ReactComponent as PngIcon } from "images/documents/Type=PNG.svg";
import { ReactComponent as WmaIcon } from "images/documents/Type=WMA.svg";
import { ReactComponent as Mp3Icon } from "images/documents/Type=MP3.svg";
import { ReactComponent as MidIcon } from "images/documents/Type=MID.svg";
import { ReactComponent as WavIcon } from "images/documents/Type=WAV.svg";
import { ReactComponent as JavaIcon } from "images/documents/Type=JAVA.svg";
import { ReactComponent as RssIcon } from "images/documents/Type=RSS.svg";
import { ReactComponent as XlsIcon } from "images/documents/Type=XLS.svg";
import { ReactComponent as JsonIcon } from "images/documents/Type=Json.svg";
import { ReactComponent as HtmlIcon } from "images/documents/Type=HTML.svg";
import { ReactComponent as XmlIcon } from "images/documents/Type=XML.svg";
import { ReactComponent as Mp4Icon } from "images/documents/Type=MP4.svg";
import { ReactComponent as MovIcon } from "images/documents/Type=MOV.svg";
import { ReactComponent as CrdIcon } from "images/documents/Type=CRD.svg";
import { ReactComponent as SvgIcon } from "images/documents/Type=SVG.svg";
import { ReactComponent as EpsIcon } from "images/documents/Type=EPS.svg";
import { ReactComponent as PsIcon } from "images/documents/Type=PS.svg";
import { ReactComponent as PptxIcon } from "images/documents/Type=PPTX.svg";
import { ReactComponent as XliffIcon } from "images/documents/Type=XLIFF.svg";
import { ReactComponent as XlsxIcon } from "images/documents/Type=XLSX.svg";
import { ReactComponent as SrtIcon } from "images/documents/Type=SRT.svg";
import { ReactComponent as GlobalIcon } from "images/documents/GlobalIcon.svg";

const iconMap = {
  pdf: PdfIcon,
  csv: CsvIcon,
  doc: DocIcon,
  docx: DocxIcon,
  pub: PubIcon,
  txt: TxtIcon,
  xsl: XslIcon,
  ppt: PptIcon,
  mdb: MdbIcon,
  zip: ZipIcon,
  rar: RarIcon,
  iso: IsoIcon,
  exe: ExeIcon,
  dll: DllIcon,
  psd: PsdIcon,
  ai: AiIcon,
  dwg: DwgIcon,
  bmp: BmpIcon,
  jpg: JpgIcon,
  tiff: TiffIcon,
  gif: GifIcon,
  flv: FlvIcon,
  avi: AviIcon,
  mpeg: MpegIcon,
  raw: RawIcon,
  png: PngIcon,
  wma: WmaIcon,
  mp3: Mp3Icon,
  mid: MidIcon,
  wav: WavIcon,
  java: JavaIcon,
  rss: RssIcon,
  xls: XlsIcon,
  json: JsonIcon,
  html: HtmlIcon,
  xml: XmlIcon,
  mp4: Mp4Icon,
  mov: MovIcon,
  crd: CrdIcon,
  svg: SvgIcon,
  eps: EpsIcon,
  ps: PsIcon,
  pptx: PptxIcon,
  xliff: XliffIcon,
  xlsx: XlsxIcon,
  srt: SrtIcon,

  // default fallback icon in case extension is not found
  default: GlobalIcon,
};

const FileIcon = ({ fileName }) => {
  if (!fileName) {
    return;
  }
  const ext = fileName?.split(".").pop().toLowerCase();
  const IconComponent = iconMap[ext] || iconMap.default;
  return <IconComponent />;
};

export default FileIcon;
